import { render } from "./AuthView.vue?vue&type=template&id=db98db52&ts=true"
import script from "./AuthView.vue?vue&type=script&lang=ts"
export * from "./AuthView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lasseborgen/Documents/Makeable/tuk-dashboard-backend/upload-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__